/**
 * Created by zhonganyun on 2018/12/23.
 */

import axios from "axios";
import {Loading} from 'element-ui';
import Vue from 'vue'

//let host = 'http://localhost:55001';

let host = process.env.VUE_APP_API_ENDPOINT; //注意变量名称需要以VUE_APP_开头
let env = process.env.NODE_ENV;
if (env === 'production') {
    host = 'VUE_API_URL_PLACE'
}

//let chatHost = 'VUE_API_URL_CHAT_PLACE';

// const service = axios.create({
//   baseURL: host,
//   // timeout: 5000,
//   headers: {
//     "Content-Type": "multipart/form-data"
//   },
// })


// function cat_params(params) {
//   let str = '';
//   for (let key in params) {
//     str += key + '=' + params[key] + "&";
//   }
//   return str;
// }
let PLATFORM = 1
if (env === 'production') {
    PLATFORM = 'VUE_PLATFORM'
}
console.log('打包环境1', env);

/**
 * =============================================
 *         ⚠️ 项目本地开发与生产环境配置说明
 *         ⚠️请勿随意修改，如需修改请联系主负责人
 * =============================================
 */
//⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️
// ⚠️TODO: 【重要提醒】本地开发C端时：https://ai.ewg1990.com/#/app ，下面params['platform'] = 2保持注释即可；          ⚠️⚠️
// ⚠️TODO: 【重要提醒】本地开发如果是admin环境：https://ai-admin.ewg1990.com/#/app，则去掉params['platform'] = 2的注释 ⚠️⚠️
// ⚠️FIXME:【重要提醒】如果admin环境或者C端域名通过变量domain控制；如果某端有变动，请修改domain变量                        ⚠️⚠️
// ⚠️FIXME:【重要提醒】开发命令：npm run serve 或 npm run dev                                                      ⚠️⚠️
// ⚠️FIXME:【重要提醒】发布命令：npm run build                                                                     ⚠️⚠️
// ⚠️FIXME:【极其提醒】发布命令浏览器日志console：ANALYZE=true npm run build                                                                   ⚠️⚠️
//⚠️⚠️⚠️⚠️⚠️⚠️⚠️TODO:【发布提醒】运行发布命令后，必须所有打包代码都提交到git仓库推送到远程，最后在Jpom相应项目执行构建部署️⚠️⚠️⚠️⚠️


function wrap_params(params) {
    params['api_version'] = 1;
    params['platform'] = PLATFORM;
    //TODO 取消注释则为ai-admin.ewg1990.com环境；注释则为ai.ewg1990.com环境
    params['platform'] = 2;
    params['terminal'] = 4;

    let domain = 'ai.ewg1990.com';
    if (PLATFORM === 2) {
        domain = 'ai-admin.ewg1990.com';
    }
    params['domain'] = env === 'production' ? window.location.hostname : domain;
    let userId = localStorage.getItem("userId") || 0;
    let token = localStorage.getItem("token") || '';
    let flag = localStorage.getItem("flag") || '4afb2b35-3466-44f1-be6d-97b664944bbe';
    params['user_id'] = userId;
    params['token'] = token;
    params['flag'] = flag;
    return params;
}

// async function getSync(data){
//   return axios.get(host + data.path, {
//     params: wrap_params(data.params)
//   })
// }

function get(data) {

    axios.get(host + data.path, {
        params: wrap_params(data.params)
    }).then(function (response) {
        //console.log(response)
        if (response.data.status === 0) {
            data.context.$message.error(response.data.errorMsg);
            if (response.data.errorCode === 2001) {
                // data.context.$router.push({path: '/app/index'});
                data.context.$router.push({path: '/Login'});
                localStorage.setItem("token", "");
                localStorage.setItem("userId", 0);
            }
        } else {
            data.success(response.data.data);
        }
    }).catch(function (error) {
        console.log(error)
    });
}


function post(data) {
    //noinspection JSUnresolvedFunction
    let loadingInstance;
    if (data.loading == null || data.loading == true) {
        //console.log(data.loading)
        loadingInstance = Loading.service({});
    }
    axios({
        method: "post",
        url: host + data.path,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: wrap_params(data.params),
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            //console.log(ret);
            return ret
        }],
    }).then(function (response) {
        //console.log(response)
        data.context.$nextTick(() => {
            if (loadingInstance)
                loadingInstance.close();
        });
        if (response.data.status === 0) {
            data.context.$message.error(response.data.errorMsg);
            if (response.data.errorCode === 2001) {
                // data.context.$router.push({path: '/app/index'});
                data.context.$router.push({path: '/Login'});
                localStorage.setItem("token", "");
                localStorage.setItem("userId", 0);
            }
            if (data.error)
                data.error();
        } else {
            data.success(response.data.data);
        }
    }).catch(function (error) {
        console.log(error);
        data.context.$nextTick(() => {
            if (loadingInstance)
                loadingInstance.close();
            if (data.error)
                data.error();
        });
    });
}

const service = axios.create({
    baseURL: process.env.API_ROOT,
    // timeout: 5000,
    headers: {
        "Content-Type": "multipart/form-data"
    },
})


function post1(data) {
    //noinspection JSUnresolvedFunction
    let loadingInstance = Loading.service({});
    let userId = localStorage.getItem("userId") || 0;
    let token = localStorage.getItem("token") || '';
    data.params.append('api_version', '1')
    data.params.append('platform', PLATFORM)
    data.params.append('terminal', '4')
    data.params.append('user_id', userId)
    data.params.append('token', token)

    service.post(host + data.path, data.params).then(response => {
        data.context.$nextTick(() => {
            if (loadingInstance)
                loadingInstance.close();
        });
        if (response.data.status == 0) {
            data.context.$message.error(response.data.errorMsg);
            if (response.data.errorCode == 2001) {
                //data.context.$router.push({path: '/login'});
                localStorage.setItem("token", "");
                localStorage.setItem("userId", 0);
            }
            if (data.error)
                data.error();
        } else {
            data.success(response.data.data);
        }

    }).catch(error => {
        console.log(error);
        data.context.$nextTick(() => {
            if (loadingInstance)
                loadingInstance.close();
            if (data.error)
                data.error();
        });
    })
}


export {
    get, post, post1, host, PLATFORM
}
